export default __webpack_public_path__ + "static/media/b1.8dc09b0f.jpg";